<arm-layout [menuTitle]="'Menu'">
  <div header>
  </div>
  <div menu class="calls-list-filter">
    <div class="filter-container">

      <div class="action-buttons-and-checkbox">

        <div class="regex-search-check-box">
          <mat-checkbox name="regExpSearch" color="primary" [(ngModel)]="search.regExpSearch">Regular Expression search</mat-checkbox>
        </div>

        <div class="action-buttons">
          <div class="abort-call-search" *ngIf="waitingForResponse">
            <i class="fa fa-stop-circle red"
               title="Abort"
               (click)="abortRequest()">
            </i>
          </div>

          <div class="clear-call-search">
            <i class="fa fa-trash"
               title="Clear search"
               (click)="clear()"
               [class.isDisabled]="isEmptySearchParameters() || waitingForResponse">
            </i>
          </div>
        </div>
      </div>

      <div class="filter-content">
        <div *ngIf="externalData">
          <mat-form-field class="filter-item-mat">
            <mat-label>Source</mat-label>
            <input [(ngModel)]="search.srcUriBeforeManipulation" matInput name="search-source-name">
          </mat-form-field>

          <mat-form-field class="filter-item-mat">
            <mat-label>Destination</mat-label>
            <input [(ngModel)]="search.dstUriBeforeManipulation" matInput name="search-dest-name">
          </mat-form-field>

          <mat-form-field class="filter-item-mat">
            <mat-label>Session Id</mat-label>
            <input [(ngModel)]="search.sessionId" matInput name="search-session-id">
          </mat-form-field>

          <div class="filter-item">
            <ac-input-container label="Incoming Node" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.incomingNodeId"
                         (acModelChange)="search.incomingNodeId = $event; onIncomingNodeChange(search.incomingNodeId);"
                         [items]="externalData.nodes"
                         [ngDisabled]="search.incommingPconId"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [allowClear]="true"
                         alternativeName="search.incomingNodeId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Incoming Peer Connection" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.incommingPconId"
                         (acModelChange)="search.incommingPconId = $event;"
                         [items]="incomingPconOptions"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [groupBy]="'nodeName'"
                         [allowClear]="true"
                         alternativeName="search.incommingPconId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Incoming Customers" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.incomingCustomerId"
                         (acModelChange)="search.incomingCustomerId = $event;"
                         [items]="customerOptions"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [allowClear]="true"
                         alternativeName="search.incomingCustomerId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Outgoing Node" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.outgoingNodeId"
                         (acModelChange)="search.outgoingNodeId = $event; onOutgoingNodeChange(search.outgoingNodeId);"
                         [items]="externalData.nodes"
                         [ngDisabled]="search.outgoingPconId"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [allowClear]="true"
                         alternativeName="search.outgoingNodeId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Outgoing Peer Connection" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.outgoingPconId"
                         (acModelChange)="search.outgoingPconId = $event;"
                         [items]="outgoingPconOptions"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [groupBy]="'nodeName'"
                         [allowClear]="true"
                         alternativeName="search.outgoingPconId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Outgoing Customers" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.outgoingCustomerId"
                         (acModelChange)="search.outgoingCustomerId = $event;"
                         [items]="customerOptions"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [allowClear]="true"
                         alternativeName="search.outgoingCustomerId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Routing rule" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.routingRuleId"
                         (acModelChange)="search.routingRuleId = $event;"
                         [items]="externalData.routingRules"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [groupBy]="'groupName'"
                         [allowClear]="true"
                         alternativeName="search.routingRuleId">
              </ac-select>
            </ac-input-container>
          </div>

          <div class="filter-item">
            <ac-input-container label="Policy studio" class="ldap-mapping-ad-attr">
              <ac-select [acModel]="search.policyStudioId"
                         (acModelChange)="search.policyStudioId = $event;"
                         [items]="externalData.policyStudios"
                         [bindValue]="'id'"
                         [bindLabel]="'name'"
                         [groupBy]="'groupName'"
                         [allowClear]="true"
                         alternativeName="search.routingRuleId">
              </ac-select>
            </ac-input-container>
          </div>

          <mat-form-field class="filter-item-mat">
            <mat-label>SIP reason</mat-label>
            <input [(ngModel)]="search.sipTerminationReason" matInput name="sip-reason">
          </mat-form-field>

          <mat-checkbox name="enableDate" color="primary" [(ngModel)]="search.enableDate" class="date-check-box">Date range</mat-checkbox>

          <div class="filter-item-mat">
            <ac-date-picker class="time-range-date-picker"
                            [acModel]="search.date"
                            (acChanged)="search.date = $event"
                            startModelName="startDate"
                            endModelName="endDate"
                            openDirection="up"
                            [options]="datePickerOptions"
                            [ngDisabled]="search.enableDate === false">
            </ac-date-picker>
          </div>
        </div>
      </div>

      <div class="filter-search-button">
        <button mat-raised-button color="primary" type="button" class="search-button"
                (click)="refresh()">Search
        </button>
        <button  mat-raised-button color="primary" type="button" class="export-button"
                 (click)="export()"
                 title="Export calls to CSV">
          <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>


  <div header>
    <div class="action-buttons">
      <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openColumnsConfiguration()">
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div main>
    <arm-table [displayedColumns]="displayedColumns" [isSelectedByDefault]="false" [data]="data"
               (onSelection)="onSelection($event)" [isMultipleSelection]="false"
               [isCursorPageTable]="true"  [isPagedTable]="false"
               [pageEventCursor]="pageEventCursor" (pageChangedCursor)="pageChanged($event)"></arm-table>
  </div>
</arm-layout>
